import React from "react";
import "./App.css";
import Routing from "./Routing/Routing";
import BasicTabs from "./Products/Productlist/Demo";

function App() {
  return (
    <div className="App">
      <Routing />
      {/* <BasicTabs/> */}
    </div>
  );
}

export default App;
